<template>
    <div class="my-3">
        <b-row align-v="end">
            <b-col class="mb-2" cols="12" md="6">
                <app-autocomplete
                    :items="clients"
                    v-model="filters.clientId"
                    label="Cliente"
                    @input="loadVenues"
                    :get-object="false"
                ></app-autocomplete>
            </b-col class="mb-2">
            <b-col class="mb-2" cols="12" md="6">
                <app-autocomplete
                    :items="venues"
                    v-model="filters.venueId"
                    label="Sede"
                    @input="loadStructures"
                    :get-object="false"
                ></app-autocomplete>
            </b-col class="mb-2">
            <b-col class="mb-2" cols="12" md="6">
                <app-autocomplete
                    :items="structures"
                    v-model="filters.structureId"
                    label="Puesto"
                    :get-object="false"
                ></app-autocomplete>
            </b-col class="mb-2">
            <b-col class="mb-2" cols="12" md="6">
                <app-autocomplete
                    :items="administrativeUsers"
                    v-model="filters.userId"
                    label="Usuario que envía"
                    :get-object="false"
                ></app-autocomplete>
            </b-col class="mb-2">
            <div class="w-100"></div>
            <b-col class="mb-2 d-flex justify-content-end" cols="12">
                <b-btn variant="primary" class="mr-2" @click="filter"
                    ><i class="fa fa-filter"></i
                ></b-btn>
                <b-btn variant="secondary" @click="clearFilters"
                    ><i class="fa fa-times"></i
                ></b-btn>
            </b-col class="mb-2">
        </b-row>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data: () => ({
        filters: {
            clientId: '',
            venueId: '',
            structureId: '',
            userId: '',
        },
        venues: [],
        structures: [],
    }),
    computed: {
        ...mapGetters(['clients', 'administrativeUsers']),
    },
    methods: {
        filter() {
            this.$emit('filter', this.filters)
        },
        clearFilters() {
            this.$emit('filter', null)
        },
        async loadVenues() {
            const { data } = await repo.get('venues', {
                client: this.filters.clientId,
            })

            this.venues = data
        },
        async loadStructures() {
            const {data} = await repo.get('structures', {venue: this.filters.venueId, accessPoint: 1})
            this.structures = data
        }
    },
    mounted() {
        this.load('clients')
        this.load('administrativeUsers')
    },
}
</script>
